/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { FormTextComponent } from "@src/app/shared/form/form-text/form-text.component";
import { Field, FieldType } from "@src/app/shared/field/Field";

export class TrendField extends Field{

    type?: FieldType = 'trend';
    visible = Field.noShow;
    sendServer = false;

    public static make(label: string, value: string, options: Partial<Field>  = {}) {
        const field: Field = new TrendField ( { label, value }, options );
        field.formControlFactory = FormTextComponent.createComponent;
        return field;
    }
}